import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';

export const ManageListingsPageLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "orgDashboard/ManageListingsPage.dynamic" */
      './ManageListingsPage.dynamic'
    ),
});
